import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { fromJS, Map } from 'immutable';
import { CustomValidators } from 'ngx-custom-validators';
import { Document } from '../../../document-data/document.model';
import { Shipping } from '../../../document-data/sub-models/shipping.model';
import { IDatePickerFieldOptions } from '../../../form-master/components/date-picker-field/date-picker-field.component';
import { IFormMasterBuilder } from '../../../form-master/form-master.interface';

@Injectable()
export class ShippingInfoDialogBuilder implements IFormMasterBuilder {
  FORM_KEYS = {
    AMOUNT: 'amount',
    SHIP_DATE: 'shipDate',
    SHIP_VIA: 'shipVia',
    TRACKING_NUMBER: 'trackingNumber',
    FOB: 'fob',
  };

  constructor(private _formBuilder: FormBuilder) {}

  buildForm(shipping: Shipping): FormGroup {
    shipping = shipping || new Shipping({});

    return this._formBuilder.group({
      [this.FORM_KEYS.AMOUNT]: [
        shipping.amount,
        CustomValidators.range([-9999999999999, 9999999999999]),
      ],
      [this.FORM_KEYS.SHIP_DATE]: [shipping.date],
      [this.FORM_KEYS.SHIP_VIA]: [shipping.via, Validators.maxLength(250)],
      [this.FORM_KEYS.TRACKING_NUMBER]: [
        shipping.trackingNumber,
        Validators.maxLength(250),
      ],
      [this.FORM_KEYS.FOB]: [shipping.fob, Validators.maxLength(250)],
    });
  }

  buildDocumentContentPropsFromShipping(
    shippingInfo: Map<string, any>,
    emptyFormValue: Map<string, any>
  ): Map<string, any> {
    return fromJS({
      [Document.CONTENT_KEYS.SHIPPING]: emptyFormValue.equals(shippingInfo)
        ? null
        : {
            [Shipping.KEYS.AMOUNT]: shippingInfo.get(this.FORM_KEYS.AMOUNT),
            [Shipping.KEYS.DATE]:
              shippingInfo.get(this.FORM_KEYS.SHIP_DATE) || null,
            [Shipping.KEYS.VIA]:
              shippingInfo.get(this.FORM_KEYS.SHIP_VIA) || null,
            [Shipping.KEYS.TRACKING_NUMBER]:
              shippingInfo.get(this.FORM_KEYS.TRACKING_NUMBER) || null,
            [Shipping.KEYS.FOB]: shippingInfo.get(this.FORM_KEYS.FOB) || null,
          },
    });
  }

  buildShippingDateOptions(): IDatePickerFieldOptions {
    return {
      allowEmptyDate: true,
    };
  }
}
